import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import ComponentMap from "../../../atom/componentmap";
import ThemedButton from "../../../atom/ThemedButton/themedButton";
import { getAllDisplayGroups } from "../../../services/api";
import { addChildrensToMapData } from "../../../services/utilities";
import { useLocation, useNavigate } from "react-router-dom";
import Notification from "../../../atom/Notification";

function UserPanelLaunch() {
  const navigate = useNavigate();
  const path = useLocation();
  const [userPanel, setUserPanel] = useState<any>([
    {
      title: "Display Group",
      name: "name",
      value: "",
      type: "dropdown",
      displayProps: { label: "name", value: "uuid" },
      childrens: [],
      errormessage: "Display Group is Required",
    },
  ]);

  const onLaunch = (e: any) => {
    if (e.name) {
      const id = e?.name;
      navigate(`${path?.pathname}/userpanel/${id}`, { replace: false });
    } else {
      Notification("Required", "Select any Display Group", "danger");
    }
  };

  const getDisplayGroupsList = () => {
    getAllDisplayGroups().then((result: any) => {
      if (!result?.success) {
      } else {
        let data = result?.data?.data;
        data = [{ uuid: "all", name: "All" }, ...data];
        setUserPanel(addChildrensToMapData([...userPanel], data, "name"));
      }
    });
  };

  useEffect(() => {
    getDisplayGroupsList();
  }, []);

  return (
    <div
      data-testid="wallboardSettings"
      className=" flex justify-center items-center h-[calc(100vh-110px)]"
    >
      <FadeIn>
        <div className="h-fit w-[520px] bg-[#FFFFFF] rounded-lg">
          <div className="text-[16px] font-bold px-7 py-4">
            User Panel Settings
          </div>

          <div className="mt-4 relative px-5">
            <ComponentMap data={userPanel} setData={setUserPanel} />
          </div>

          <div className=" w-full h-full py-4 flex items-baseline justify-end mt-4 -ml-6 ">
            <ThemedButton
              children={"Launch"}
              icon="custom"
              theme="primary"
              valiData={userPanel}
              change={setUserPanel}
              click={onLaunch}
            />
          </div>
        </div>
      </FadeIn>
    </div>
  );
}

export default UserPanelLaunch;
